// Layout.jsx
import React from 'react';
import './Layout.css';
import Header from './Header';
import Footer from './Footer';
import SocialIcons from './Socialicons';
import ScrollToTopButton from "./ScrollToTopButton";
import TawkToWidget from "./TawkToWidget";
import { Outlet } from 'react-router-dom';

function Layout() {
    return (
        <div className="page-wrapper">
            <Header />
            <SocialIcons />
            <main className="page-content1">
                <Outlet />
            </main>
            <Footer />
            <ScrollToTopButton />
            <TawkToWidget />
        </div>
    );
}

export default Layout;
